import {Component, EventEmitter, forwardRef, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {ListResponse} from "../../interface/response/list-response";
import {DOCUMENT} from "@angular/common";
import {debounceTime, distinctUntilChanged, startWith, takeUntil} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import {AddressImportRowService} from "../../services/address-import-row.service";
import {AddressImportRow} from "../../interface/address-import-row";
import {ADDRESS_IMPORT_TYPE, DICT_TYPE_FILE_TYPE, DictService} from "../../services/dict.service";

@Component({
  selector: 'app-dict-address',
  templateUrl: './dict-address.component.html',
  styleUrls: ['./dict-address.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictAddressComponent)}
  ]
})
export class DictAddressComponent  implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() label: string;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() filterProfit = false;
  @Input() onlyActive = false;
  @Input() dictType: string[];
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();

  externalControl = true;
  disabled = false;
  items: AddressImportRow[] = [];
  itemsSubject: ReplaySubject<ListResponse<AddressImportRow>> = new ReplaySubject<ListResponse<AddressImportRow>>(1);
  value?: string = null;
  selectedValue?: string = null;
  type?: number[] = null;
  filterCtrl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private addressImportRowService: AddressImportRowService,
    @Inject(DOCUMENT) private document: Document,
    private fb: FormBuilder,
    private dictService: DictService,
  ) {
    this.filterCtrl = fb.control('');
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit(): void {
    if (this.type === null ) {
      this.type = [];
      this.dictType.forEach((typ: string) => {
        this.dictService.getId(typ, ADDRESS_IMPORT_TYPE)
          .subscribe((dictId: number) => {
            this.type.push( dictId);
          });
      });
    }
    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }

    this.control.valueChanges
      .pipe(
        startWith(this.control.value),
        takeUntil(this.destroyed$)
      )
      .subscribe((val: string) => {
        if (val) {
          let exists = false;
          this.items.forEach((value: AddressImportRow) => {
            if (value.value === val) {
              exists = true;
            }
          });

          if (!exists && val) {
            this.addressImportRowService
              .loadNotCountedList(
                0,
                9999,
                {in$value: val,
                  in$type: this.type
                },
                this.itemsSubject
              );
          }
        }
      });

    this.filterCtrl.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
        if (val) {
          this.addressImportRowService.loadNotCountedList(0, 50, {
            context: val,
            in$type: this.type,

          }, this.itemsSubject);
        } else if (this.control.value) {
          this.addressImportRowService
            .loadNotCountedList(
              0,
              9999,
              { in$type: this.type,
                in$value: this.control.value
              },
              this.itemsSubject
            );
        }
      });

    this.itemsSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: ListResponse<AddressImportRow>) => {
        this.items = result.items;
          this.items.forEach((value: AddressImportRow) => {
              this.selected.emit(value.value);
          });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (!value) {
      this.selectedValue = '';
    }
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue( '');
    this.writeValue( '');
    this.onChange(this.value);
  }

}
